import { render, staticRenderFns } from "./ModalAddApprover.vue?vue&type=template&id=5f147f6c&scoped=true&"
import script from "./ModalAddApprover.vue?vue&type=script&lang=ts&"
export * from "./ModalAddApprover.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAddApprover.vue?vue&type=style&index=0&id=5f147f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f147f6c",
  null
  
)

export default component.exports